import { update } from '../api/customer'
import { updateCustomer } from '../customers/action'
import { modalToggle } from '../modal/action'
import * as types from './types';

const request = () => {
  return {
    type: types.REQUEST,
    payload: true,
  }
}

const success = customer => {
  return {
    type: types.SUCCESS,
    payload: customer,
    error: null
  }
}

const error = error => {
  return {
    type: types.ERROR,
    payload: error,
  }
}

const onSelectCustomer = customer => {
  return dispatch => { 
    dispatch(success(customer));
  }
}

const onChangeStatus = customer => {
  return dispatch => { 
    dispatch(request());
    update(customer.id, { status: customer.status === 1 ? 2 : 1 })
      .then(res => {
        Promise.all([
          dispatch(success(res.data.data)), 
          dispatch(updateCustomer(res.data.data)),
          dispatch(modalToggle(false))
        ]);
    }).catch(e => {
      dispatch(error(e.response.data.error))
    });
  }
}
 
export {
  onChangeStatus,
  onSelectCustomer,
  request,
  success,
  error
};



// WEBPACK FOOTER //
// ./src/store/customer/action.js